/* eslint-disable react/jsx-curly-brace-presence */
import React from 'react';
import PropTypes from 'prop-types';
import Box from 'ui-box';
import { Button } from 'antd';

function MobileButtonFooter({onClick, title}) {
  return (
    <Box
      position="absolute"
      bottom="50px"
      marginLeft="auto"
      marginRight="auto"
      left="0"
      right="0"
      width="100%"
      maxWidth="480px"
      paddingX={20}
    >
      <Button
        htmlType="button"
        type="primary"
        size="large"
        onClick={onClick}
        block
      >
        {title}
      </Button>
    </Box>
  );
}

MobileButtonFooter.defaultProps = {
  onClick: () => null,
  title: ''
};

const { func, string } = PropTypes;

MobileButtonFooter.propTypes = {
  onClick: func,
  title: string
};

export default MobileButtonFooter;
